<!-- 场馆预览   mjs -->
<template>
 <div class="digitalpavilioncontainer pb100">
    <banner/>
    <crumbs/>
    <div class="container listcontainer">
        <type-screen modelType="digital" :menu-id="menuId" @typeObj="selectType"/>

        <ul class="szzg_list">
          <li v-for="item in digitlist" :key="item.id" @click="detaillink(item.id)">
            <img :src="getImage(item.image)" class="cgyd_shdow"/>
            <div class="intro_con">
                <h4>{{item.title}}</h4>
                <p class="intro_con_dress">{{item.address}}</p>
                <p class="intro_con_tel">{{item.phone}}</p>
                <p class="intro_con_txt" v-html="item.synopsis"> </p>
            </div>
          </li>
        </ul>
        <nodata v-show="nodataflag"/>

     <el-pagination
        @current-change="handleCurrentChange"
        :page-size="digitparams.limit"
        :pager-count="5"
        layout="prev, pager, next"
        :total="total"
        class="pagemodel1">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import {getdigitlist} from '@/api/digitalpavilion/index'
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
export default {
  name: 'digitalpavilion',
  meta: { showHeader: true },
  components: {
    crumbs, typeScreen, nodata, banner
  },
  data () {
    return {
      menuId: '',
      total: 0,
      digitparams: {
        page: 1,
        limit: 8,
        menuId: '',
        types: null,
        areaType: null,
        type: null,
        codes: ''
      },
      digitlist: [],
      nodataflag: false
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.digitparams.menuId = this.$route.query.columnId
    this.getdigitallist()
  },
  methods: {
    getdigitallist () {
      getdigitlist(this.digitparams).then(res => {
        console.log(res)
        this.total = res.data.list.data.total
        if (this.total === 0) {
          this.nodataflag = true
        } else {
          this.nodataflag = false
        }
        this.digitlist = res.data.list.data.rows
      })
    },
    getImage (val) {
      if (val === undefined || val === '') {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    selectType (obj) {
      if (obj.codes !== undefined) {
        this.digitparams.codes = obj.codes.toString()
      }
      this.digitparams.areaType = obj.areaType
      this.digitparams.type = obj.type
      this.digitparams.types = obj.customTypeId
      this.getdigitallist()
    },
    handleCurrentChange (val) {
      this.digitparams.page = val
      this.getdigitallist()
    },
    detaillink (id) {
      this.$router.push({
        path: '/digitalpaviliondetail',
        query: {id, columnId: this.menuId}
      })
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/digitalpavilion.scss'
</style>



// WEBPACK FOOTER //
// src/view/digitalpavilion/list.vue